import { QUESTIONNAIRE_CODE } from 'lib/constants';

export const questionNumber: Record<QUESTIONNAIRE_CODE, number> = {
  [QUESTIONNAIRE_CODE.BODY_TYPE]: 1,
  [QUESTIONNAIRE_CODE.FITNESS_LEVEL]: 2,
  [QUESTIONNAIRE_CODE.SLEEP_LEVEL]: 3,
  [QUESTIONNAIRE_CODE.SLEEP_QUALITY]: 4,
  [QUESTIONNAIRE_CODE.STRESS_LEVELS]: 5,
  [QUESTIONNAIRE_CODE.EATING_HABITS]: 6,
  [QUESTIONNAIRE_CODE.WATER_CONSUMPTION]: 7,
  [QUESTIONNAIRE_CODE.ALCOHOL_CONSUMPTION]: 8,
  [QUESTIONNAIRE_CODE.SMOKING]: 9,
  [QUESTIONNAIRE_CODE.MEDICAL_CONDITIONS]: 10,
  [QUESTIONNAIRE_CODE.SPECIFY_MEDICAL_CONDITION]: 10,
  [QUESTIONNAIRE_CODE.FAMILY_MEDICAL_CONDITIONS]: 11,
  [QUESTIONNAIRE_CODE.ONGOING_ALLERGIES]: 12,
  [QUESTIONNAIRE_CODE.SURGERY]: 13,
  [QUESTIONNAIRE_CODE.TAKING_MEDICATIONS]: 14,
  [QUESTIONNAIRE_CODE.SPECIFY_MEDICATION]: 14,
  [QUESTIONNAIRE_CODE.FACESCAN]: 15,
};
